<template>
  <div class="user-summary">
    <div class="user-summary__column">
      <userpic class="hidden-xs"
               :user="user"
               :upic="user.getUpic()"
               :name="user.getLastName()"
               size="medium"
               :editLink="editLink"
               :perms="perms"
               :isMyProfile="isMyProfile"></userpic>
      <user-name class="visible-xs-block"
                :user="user"
                size="medium"
                :editLink="editLink"
                :perms="perms"
                :isMyProfile="isMyProfile"></user-name>
      <!-- <rating></rating> -->
      <messengers :user="user"></messengers>
      <contacts :contacts="user.getContacts()"></contacts>
      <login-data :user="user"></login-data>
      <system-info class="hidden-xs" :user="user"></system-info>
      <qrcode class="hidden-xs"></qrcode>
    </div>
    <div class="user-summary__column">
      <user-name class="hidden-xs user-summary__item"
                 :user="user"
                 :editLink="editLink"
                 :perms="perms"
                 :isMyProfile="isMyProfile"></user-name>

      <info-block :title="$t('labels.work_place')" marker-color="#8099f5" :expandedContent="true" :imaginaryHeader="true">
        <div class="workplaces-container user-summary__item">
          <template v-if="user.getOrgs().length">
            <workplace v-for="(place, index) in user.getOrgs()"
              :key="index"
              :place="place"
              :user-id="user.getId()"
              :workplaceRowHeights="workplaceRowHeights"
              :index="index">
            </workplace>
          </template>
          <div v-else>
            <workplace :place="null"></workplace>
          </div>
        </div>
      </info-block>

      <note :regalia="user.getNote()" class=" user-summary__item"></note>
      <system-info class="visible-xs hidden-md" :user="user"></system-info>
      <qrcode class="visible-xs hidden-md"></qrcode>
    </div>
  </div>
</template>
<script>
  import userpic from './userpic.vue';
  import contacts from './contacts.vue';
  import loginData from './loginData.vue';
  import userName from './name.vue';
  import workplace from './workplace.vue';
  import note from './note.vue';
  import systemInfo from './systemInfo.vue';
  import qrcode from './qrcode.vue';
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  import messengers from './msgrs.vue'

  export default {
    props: {
      user: {
        type: Object,
        default: () => {}
      },
      profile: {
        type: Object,
        default: () => {}
      },
      isMyProfile: Boolean,
      perms: {
        type: Object,
        default: () => {}
      }
    },
    components: {
      userpic,
      contacts,
      loginData,
      userName,
      workplace,
      note,
      systemInfo,
      qrcode,
      infoBlock,
      messengers
    },
    data () {
      return {
        userOrgs: null,
        workplaceRowHeights: {
          place: 0,
          occupation: 0,
          role: 0,
        },
        calcWorkplaceRowHeights: null,
      }
    },
    methods: {
      getcalcWorkplaceRowHeights () {
        if (!this.calcWorkplaceRowHeights) {
          this.calcWorkplaceRowHeights = (function () {
            setTimeout(() => {
              this.workplaceRowHeights.place = getMaxHeight(this.$el, 'place');
              this.workplaceRowHeights.occupation = getMaxHeight(this.$el, 'occupation');
              this.workplaceRowHeights.role = getMaxHeight(this.$el, 'role');
            }, 1000);

            function getMaxHeight (el, prop) {
              const dataHeights = [];
              const labelElement = el.querySelector(`.profile-workplace__row--${prop} > .profile-block__row-label`);
              const dataElements = el.querySelectorAll(`.profile-workplace__row--${prop} > .profile-block__row-data`);
              if (dataElements.length > 1) {
                dataElements.forEach((el) => {
                  dataHeights.push(el.clientHeight);
                });
                return Math.max(...dataHeights) + labelElement.clientHeight;
              } else {
                return 0;
              }
            }
          }).bind(this);
        }

        return this.calcWorkplaceRowHeights;
      }
    },
    beforeMount () {
      window.addEventListener('resize', this.getcalcWorkplaceRowHeights());
      this.$bus.$on('User:getUserProfile.success', this.getcalcWorkplaceRowHeights())
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getcalcWorkplaceRowHeights());
    },
    computed: {
      editLink: self => {
        if (!self.isMyProfile || self.isSuperAdmin || self.hasUserUpdatePerm) {
          return 'editUser'
        } else {
          return 'editMyProfile'
        }
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.user-page{
  .info-block__content{padding-top: 0 !important;}
}
.user-summary {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-column-gap: 30px;

  @media (max-width: $screen-sm){
     grid-template-columns: 1fr;
  }

  &__column {
    display: grid;
    grid-auto-rows: max-content;
    min-width: 0;
  }
  &__item {
    overflow-x: auto;
  }

  .workplaces-container {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 20px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
    border-radius: $global-radius;
    overflow: hidden;
    background: #fff;

    @media (max-width: $screen-lg){
      grid-template-columns: 1fr;
    }

    // &:before {
    //   content: '';
    //   position: absolute;
    //   z-index: 1;
    //   left: 0;
    //   top: 0;
    //   height: 100%;
    //   background: #fff;
    //   width: 1px;
    // }

    &:after {
      content: '';
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 100%;
      background: #fff;
    }
  }
  .services-container{
    .el-table{
      &:before{
        display: none;
        height: 0px;
      }
      tr{
        &:last-of-type{
          td{
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>